import { MOBILE_VIEW_BREAKPOINT } from '../constants/size';

const getSitesTappWidth = (width: number, hideOtherContent: boolean, isMyChaynsApp: boolean): number => (width >= MOBILE_VIEW_BREAKPOINT && !hideOtherContent && !isMyChaynsApp ? width - 740 : width);

export default getSitesTappWidth;
